// extracted by mini-css-extract-plugin
export default {"link":"tooltip_link__oSqOY","tooltip":"tooltip_tooltip__rqR-K"};